import React from "react";
import { useTranslation } from "react-i18next";
import LogoSmall from "../../assets/img/brand/artur_head.svg";

function AdminFooter() {
  const { t } = useTranslation();

  return (
    <footer className="container-fluid">
      <div className="row">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="footerLinks">
                <ul>
                  <li>
                    <img
                      src={LogoSmall}
                      alt="Artur logo"
                      className="brandLogo"
                    />
                  </li>
                  <li>Cohortem, d.o.o.</li>
                  {/**<li>
                                        {t("footer.tech")}:{" "}
                                    </li>**/}
                  <li>
                    <a href="/pogoji-uporabe">{t("footer.terms")}</a>
                  </li>
                  {/*<li>
                    {<a href="https://www.vsestoritve.com/piskotki">
                      {t("footer.cookies")}
                    </a>
                  </li>*/}
                  <li>
                    <a href="mailto:info@artur.com?Subject=Brezplačni preizkus artur.com">
                      {t("footer.write")}
                    </a>
                  </li>
                  <li>
                    {t("footer.call")}{" "}
                    <a href="tel:0038651207820">+386 51 207 820</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default AdminFooter;
